export default __webpack_public_path__ + "static/media/samplePDF.38a8bceb.pdf";